module.exports = __webpack_public_path__ + "img/integral-item1.ab356afa.png";